//REDUCER for catalog
import { RECIEVE_SEARCH, RECIEVE_SEARCH_LANGUAGE, RECIEVE_SEARCH_TOPICS, SET_CATALOG_INITIALIZED, SET_QUERY, SET_PRUNE_TOPIC, SET_PRUNE_LANGUAGE, SET_SORT, SET_SORT_COURSES, CLEAR_FILTERS} from '../actions'

import  Ajv from 'ajv';
import searchEntrySchema from '../schema/SearchEntry.schema.js';
import searchSchema from '../schema/Search.schema.js';

import { createAction, createReducer } from '@reduxjs/toolkit'

const initialCatalogState = {
    validationErrors:[],
    searchModules: [],
    searchCourses: [],
    searchUCourses: [],
    modules: [],
    courses: [],
    ucourses: [],
    sortOptionSelected: 0,
    sortOptionCoursesSelected: 0,
    pruneModules: [],
    pruneCourses: [],
    pruneUCourses: [],
    pruneTopic: 0,
    pruneLanguage: 0,
    query: "",
    topics: [],
    languages: [],
    ready: false
};


const catalog = createReducer(initialCatalogState, (builder) => {
  builder
    .addCase(createAction(SET_CATALOG_INITIALIZED), (state, action) => {
        state.ready = action.bool;
    })
    .addCase(createAction(RECIEVE_SEARCH), (state, action) => {

        let ajv = new Ajv(); // options can be passed, e.g. {allErrors: true}
        let validate = ajv.compile(searchSchema);
        let valid = validate(action.json);
        if (!valid) 
        {
            state.validationErrors.push({"entry" : action.json, "errors" : validate.errors} );
        }else{

            validate = ajv.compile(searchEntrySchema);
            state.modules = action.json.modules.filter(function(entry) 
            {
                valid = validate(entry);
                if(!valid)
                {   
                    state.validationErrors.push({"entry" : entry, "errors" : validate.errors} );
                }
                return valid;
            });

            // validate = ajv.compile(searchEntrySchema);
            state.courses = action.json.courses.filter(function(entry) 
            {
                /*
                valid = validate(entry);
                if(!valid)
                {   
                    s.validationErrors.push({"entry" : entry, "errors" : validate.errors} );
                }
                */
                return valid;
            });

            // validate = ajv.compile(searchEntrySchema);
            state.ucourses = action.json.ucourses.filter(function(entry) 
            {
                /*
                valid = validate(entry);
                if(!valid)
                {   
                    s.validationErrors.push({"entry" : entry, "errors" : validate.errors} );
                }
                */
                return valid;
            });
            
            if(state.validationErrors.length === 0)
            {
                state.topics = action.json.topics;
                state.languages = action.json.languages;

               // state.modules = action.json.modules;

                state.pruneModules = prune(state,  action.json.modules);
                state.searchModules = searchQuery("", state.pruneModules).sort(getLessonSortFunction(0));

                state.pruneCourses = prune(state,  action.json.courses);
                state.searchCourses = searchQuery(state.query, state.pruneCourses).sort(getCoursesSortFunction(0));

                state.pruneUCourses = prune(state,  action.json.ucourses);
                state.searchUCourses = searchQuery(state.query, state.pruneUCourses).sort(getCoursesSortFunction(0));
            }   
        }

        
    })
    .addCase(createAction(SET_QUERY), (state, action) => {
        state.query = action.query;

        state.pruneModules = prune(state, state.modules);
        state.searchModules = searchQuery(state.query, state.pruneModules).sort(getLessonSortFunction(state.sortOptionSelected));

        state.pruneCourses = prune(state, state.courses);
        state.searchCourses = searchQuery(action.query, state.pruneCourses).sort(getCoursesSortFunction(state.sortOptionCoursesSelected));

        state.pruneUCourses = prune(state, state.ucourses);
        state.searchUCourses = searchQuery(action.query, state.pruneUCourses).sort(getCoursesSortFunction(state.sortOptionCoursesSelected));
        
    })
    .addCase(createAction(SET_PRUNE_TOPIC), (state, action) => {
        state.pruneTopic = parseInt(action.meta_id, 10);

        state.pruneModules = prune(state, state.modules);
        state.searchModules = searchQuery(state.query, state.pruneModules).sort(getLessonSortFunction(state.sortOptionSelected));

        state.pruneCourses = prune(state, state.courses);
        state.searchCourses = searchQuery(state.query, state.pruneCourses).sort(getCoursesSortFunction(state.sortOptionCoursesSelected));

        state.pruneUCourses = prune(state, state.ucourses);
        state.searchUCourses = searchQuery(state.query, state.pruneUCourses).sort(getCoursesSortFunction(state.sortOptionCoursesSelected));
        
    })
    .addCase(createAction(SET_PRUNE_LANGUAGE), (state, action) => {
        state.pruneLanguage = parseInt(action.id, 10);
        
        state.pruneModules = prune(state, state.modules);
        state.searchModules = searchQuery(state.query, state.pruneModules).sort(getLessonSortFunction(state.sortOptionSelected));

        state.pruneCourses = prune(state, state.courses);
        state.searchCourses = searchQuery(state.query, state.pruneCourses).sort(getCoursesSortFunction(state.sortOptionCoursesSelected));

        state.pruneUCourses = prune(state, state.ucourses);
        state.searchUCourses = searchQuery(state.query, state.pruneUCourses).sort(getCoursesSortFunction(state.sortOptionCoursesSelected));

    })
    .addCase(createAction(SET_SORT), (state, action) => {
        state.sortOptionSelected = parseInt(action.sort,10);

        state.pruneModules = prune(state, state.modules);
        state.searchModules = searchQuery(state.query, state.pruneModules).sort(getLessonSortFunction(state.sortOptionSelected));
        
    })
    .addCase(createAction(SET_SORT_COURSES), (state, action) => {
        state.sortOptionCoursesSelected = parseInt(action.sort,10); 

        state.pruneCourses = prune(state, state.courses);
        state.searchCourses = searchQuery(state.query, state.pruneCourses).sort(getCoursesSortFunction(state.sortOptionCoursesSelected));

        state.pruneUCourses = prune(state, state.ucourses);
        state.searchUCourses = searchQuery(state.query, state.pruneUCourses).sort(getCoursesSortFunction(state.sortOptionCoursesSelected));
        
    })
    .addCase(createAction(CLEAR_FILTERS), (state, action) => {
        state.pruneTopic = 0;
        state.pruneLanguage = 0;
        state.query  = "";

        state.pruneModules = prune(state, state.modules);
        state.searchModules = searchQuery(state.query, state.pruneModules).sort(getLessonSortFunction(state.sortOptionSelected));

        state.pruneCourses = prune(state, state.courses);
        state.searchCourses = searchQuery(state.query, state.pruneCourses).sort(getCoursesSortFunction(state.sortOptionCoursesSelected));

        state.pruneUCourses = prune(state, state.ucourses);
        state.searchUCourses = searchQuery(state.query, state.pruneUCourses).sort(getCoursesSortFunction(state.sortOptionCoursesSelected));
        
    })
    .addCase(createAction(RECIEVE_SEARCH_LANGUAGE), (state, action) => {
        state.languages = action.json.languages;
    })
    .addCase(createAction(RECIEVE_SEARCH_TOPICS), (state, action) => {
        state.topics = action.json.topics; 
    })
})


export function getLessonSortFunction(n)
{
    switch(n ) {
        case 0:
            return sortByPublishDateDESC;
        case 1:
            return sortByPublishDateASC;
        case 2:
            //TODO Filter out all lessons that don't have an updated date
            return sortByUpdatedDateDESC;
        case 3:
            return sortByUpdatedDateASC;
        case 4:
            return sortBySkillDESC;
        case 5:
            return sortBySkillASC;

        default:
            return sortByPublishDateDESC;
    }
}

export function sortByPublishDateASC(a, b)
{
    let a_mill = Date.parse(a.json.publish_date);
    let b_mill = Date.parse(b.json.publish_date);

    //Always sort improperly set dates to the bottom. 
    if(isNaN(a_mill) && isNaN(b_mill))
    {
        return 0;
    }else if(isNaN(a_mill))
    {
        return 1;
    }else if(isNaN(b_mill))
    {
        return -1;
    }

    return a_mill - b_mill;
}

export function sortByPublishDateDESC(a, b)
{
    let a_mill = Date.parse(a.json.publish_date);
    let b_mill = Date.parse(b.json.publish_date);

    //Always sort improperly set dates to the bottom. 
    if(isNaN(a_mill) && isNaN(b_mill))
    {
        return 0;
    }else if(isNaN(a_mill))
    {
        return 1;
    }else if(isNaN(b_mill))
    {
        return -1;
    }

    return b_mill - a_mill;
}

export function sortByUpdatedDateASC(a, b)
{
    let a_mill = Date.parse(a.json.last_update);
    let b_mill = Date.parse(b.json.last_update);

    //Always sort improperly set dates to the bottom. 
    if(isNaN(a_mill) && isNaN(b_mill))
    {
        return 0;
    }else if(isNaN(a_mill))
    {
        return 1;
    }else if(isNaN(b_mill))
    {
        return -1;
    }

    return a_mill - b_mill;
}

export function sortByUpdatedDateDESC(a, b)
{
    let a_mill = Date.parse(a.json.last_update);
    let b_mill = Date.parse(b.json.last_update);

    //Always sort improperly set dates to the bottom. 
    if(isNaN(a_mill) && isNaN(b_mill))
    {
        return 0;
    }else if(isNaN(a_mill))
    {
        return 1;
    }else if(isNaN(b_mill))
    {
        return -1;
    }

    return b_mill - a_mill;
}

export function sortBySkillASC(a, b)
{
    return b.json.content_level - a.json.content_level;
}

export function sortBySkillDESC(a, b)
{
    return a.json.content_level - b.json.content_level;
}


export function getCoursesSortFunction(n)
{
    switch(n ) {
        case 0:
            return sortByTitleDESC;
        case 1:
            return sortByTitleASC;
        default:
            return sortByTitleDESC;
    }
}

export function sortByTitleDESC(a, b)
{
   
    if(a.json.title < b.json.title) { return -1; }
    if(a.json.title > b.json.title) { return 1; }
    return 0;
}

export function sortByTitleASC(a, b)
{
    if(a.json.title < b.json.title) { return 1; }
    if(a.json.title > b.json.title) { return -1; }
    return 0;
}

function prune(state, modules)
{
    let pl = pruneLangauge(state.pruneLanguage, modules);
    return pruneTopic(state.pruneTopic, pl);

}


function pruneTopic(pruneTopic, modules)
{
    if(pruneTopic === 0)
    {
        return modules;
    }else
    {
        return modules.filter(item => { 

            return item.json.topic_meta_ids.includes(pruneTopic)
        });
    }
    
}

function pruneLangauge(pruneLangauge, modules)
{
    if( pruneLangauge === 0)
    {
        return modules;
    }else
    {
        return modules.filter(item => { 

            if(parseInt(item.json.language_id, 10) === pruneLangauge )
            {
                return true;
            }
            return false;
        });
    }
}


function searchQuery(query, modules)
{
    return modules.filter(item => { 
        
        delete item.json.titleFind;

        let haystack = item.json.title.toLowerCase();
        let needle = query.toLowerCase()
        if( haystack.includes(needle) )
        {
            let index = item.json.title.toLowerCase().indexOf(query.toLowerCase());
            if (index >= 0) 
            { 
                let title = item.json.title;
                item.json.titleFind = title.substring(0,index) + "<span style='background-color: orange;'>" + title.substring(index,index + query.length) + "</span>" + title.substring(index + query.length);
            }
            
            
            return true;
        }
        return false;
    });
}


export default catalog;